import { companyQueryKeys } from '@/hooks/queries/company.queries';
import { CompanyService } from '@/services/company.service';
import { useInfiniteQuery } from '@tanstack/react-query';

const REVIEWS_PAGE_SIZE = 6;

export function useCompanyReviews(companyId?: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: companyQueryKeys.reviews(companyId),
    enabled: enabled && Boolean(companyId),
    initialPageParam: 0,
    queryFn: ({ pageParam }) => {
      if (!companyId) {
        throw new Error('Company ID is required');
      }

      return CompanyService.getReviews(companyId, pageParam, REVIEWS_PAGE_SIZE);
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.hasMore ? lastPage.pagination.skip + lastPage.pagination.count : undefined,
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
